export default __webpack_public_path__ + "static/media/wuts-logo.8d59eadd.svg";